exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-477655cc]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-477655cc]{display:none !important}}.product__review[data-v-477655cc]{padding-bottom:24px;border-bottom:var(--c-light) solid 1px;margin-bottom:var(--spacer-base)}.product__review[data-v-477655cc]:last-of-type{border:none;padding-bottom:0;margin-bottom:0}@media (min-width: 1024px){.product__review[data-v-477655cc]{padding-bottom:0}}.product__reviews-pagination[data-v-477655cc]{margin:var(--spacer-lg) 0 0}.m-review-list[data-v-477655cc]{margin-top:var(--spacer-base)}\n", ""]);

// exports
